(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'basePage', {
            templateUrl:    'app/views/base-page.html',
            controller:     BasePageController,
            controllerAs:   'vm'
        });


    /**
     * @param {MetaService} MetaService
     * @param {LoadingService} LoadingService
     */
    function BasePageController(
        MetaService,
        LoadingManager
    ){
        this.loadingManager = LoadingManager;
    }


    BasePageController.$inject = [ 'MetaService', 'LoadingManager' ];
}());
